import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { Roles } from '@enums/roles.enum';

/**
 * Leitet Technical auf /technical und Account auf /account um (für Root-Route '').
 */
@Injectable({
  providedIn: 'root'
})
export class RoleRedirectGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authenticationService.isAccessTokenValid()) {
      return true;
    }
    if (this.authenticationService.userHasRole(Roles.Technical)) {
      this.router.navigate(['/technical'], { replaceUrl: true });
      return false;
    }
    if (this.authenticationService.userHasRole(Roles.Account)) {
      this.router.navigate(['/account'], { replaceUrl: true });
      return false;
    }
    return true;
  }
}
